import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useParams } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import { PrivacyPage, CookiesPage, TermsPage } from "@/pages/Legal";
import ThankYou from "@/pages/ThankYou";

const supported = ["mx", "en"];

function LangGate() {
  const { lang } = useParams();
  if (!supported.includes(lang)) return <Navigate to="/mx" replace />;
  return (
    <I18nProvider>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </I18nProvider>
  );
}

function ThankYouShell() {
  // Thank you is Spanish only, uses its own minimal layout (no shared header/footer)
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/mx" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LangGate />}>
          <Route index element={<Home />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="cookies" element={<CookiesPage />} />
          <Route path="terms" element={<TermsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/mx" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return <ThankYouShell />;
}
